import React from 'react';

import { IconProps } from './type';

const FilterIcon: React.FC<IconProps> = ({ className = '', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.07601 4.47383C3.21007 4.18488 3.49965 4 3.81819 4H20.1818C20.5003 4 20.7899 4.18488 20.924 4.47383C21.0581 4.76278 21.0122 5.10327 20.8065 5.3465L14.4545 12.8577V19.5454C14.4545 19.829 14.3077 20.0923 14.0665 20.2414C13.8253 20.3905 13.5241 20.4041 13.2705 20.2772L9.99774 18.6409C9.72055 18.5023 9.54546 18.219 9.54546 17.9091V12.8577L3.19345 5.3465C2.98776 5.10327 2.94194 4.76278 3.07601 4.47383ZM5.58162 5.63636L10.9884 12.0299C11.1133 12.1776 11.1818 12.3647 11.1818 12.5582V17.4034L12.8182 18.2216V12.5582C12.8182 12.3647 12.8867 12.1776 13.0116 12.0299L18.4184 5.63636H5.58162Z"
      fill="currentColor"
    />
  </svg>
);

export default FilterIcon;
